import React, { useState, useEffect, useCallback } from 'react';
import {
    Card, CardBody, CardHeader, Col, Row, Button, Table,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { MdRemoveRedEye } from 'react-icons/md';

import Page from '../components/Page';
import ReactDataTable from '../mycomponents/ReactDataTable';
import { dateTimeFormat } from '../lib/date';
import { getContactList } from '../api/admin';

const ContactList = () => {

    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState({ page: "", limit: "", search: "" });

    // Modal state
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState(null);

    const openModal = (row) => {
        setSelected(row);
        setModal(true);
    };

    const closeModal = () => {
        setModal(false);
        setSelected(null);
    };

    const columns = [
        { key: "name",      text: "Name",       className: "name",      align: "left", sortable: false },
        { key: "email",     text: "Email",      className: "email",     align: "left", sortable: false },
        { key: "phone",     text: "Phone",      className: "phone",     align: "left", sortable: false },
        { key: "type",      text: "Type",       className: "type",      align: "left", sortable: false },
        {
            key: "createdAt", text: "Created At", className: "createdAt", align: "left", sortable: false,
            cell: ({ createdAt }) => dateTimeFormat(createdAt)
        },
        {
            key: "action", text: "Action", className: "action", align: "left", sortable: false,
            cell: (row) => (
                <Button color="secondary" size="sm" onClick={() => openModal(row)}>
                    <MdRemoveRedEye />
                </Button>
            )
        }
    ];

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const { status, result } = await getContactList(pagination);
            setLoader(false);
            if (status === true) {
                setData(result.data);
                setCount(result.count);
            }
        } catch (err) { }
    }, [pagination]);

    useEffect(() => {
        fetchData();
    }, [pagination, fetchData]);

    // Detail row component for reuse
    const DetailRow = ({ label, value }) => (
        <tr>
            <td style={{ width: '35%', fontWeight: 500, color: '#555', paddingTop: '10px', paddingBottom: '10px', borderTop: '1px solid #f0f0f0', verticalAlign: 'top' }}>
                {label}
            </td>
            <td style={{ paddingTop: '10px', paddingBottom: '10px', borderTop: '1px solid #f0f0f0', color: '#222', wordBreak: 'break-word' }}>
                {value || <span style={{ color: '#bbb' }}>—</span>}
            </td>
        </tr>
    );

    return (
        <Page
            title="Lead List"
            breadcrumbs={[{ name: 'Lead List', active: true }]}
            className="TablePage"
        >
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader className="d-flex align-items-center justify-content-between">
                            <span>Lead List</span>
                        </CardHeader>
                        <CardBody>
                            <Table responsive={false}>
                                <ReactDataTable
                                    columns={columns}
                                    records={data}
                                    count={count}
                                    loader={loader}
                                    setPagination={setPagination}
                                />
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* VIEW MODAL */}
            <Modal isOpen={modal} toggle={closeModal} centered size="md">
                <ModalHeader toggle={closeModal}>
                    Details
                </ModalHeader>
                <ModalBody>
                    {selected && (
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                            <tbody>
                                <DetailRow label="Name"    value={selected.name} />
                                <DetailRow label="Email"   value={selected.email} />
                                <DetailRow label="Phone"   value={selected.phone} />
                                <DetailRow label="Type"    value={selected.type} />
                                <DetailRow label="Budget"  value={selected.budget} />
                                <DetailRow label="Details" value={selected.details} />
                                <DetailRow label="Received" value={dateTimeFormat(selected.createdAt)} />
                            </tbody>
                        </table>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeModal}>Close</Button>
                </ModalFooter>
            </Modal>
        </Page>
    );
};

export default ContactList;